// extracted by mini-css-extract-plugin
export default {"ldio":"Loader_ldio__9tKiY","loadingio":"Loader_loadingio__HzgiA"};